import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
// 	{
// 	path: '/logo',
// 	name: 'logo',
// 	redirect: '/',
// 	component: () => import('../views/home.vue'),
// 	meta: {
// 		title: "",
// 		value: "logo",
// 		isShow: true
// 	},
// },
{
		path: '/',
		name: 'home',
		component: () => import('../views/home.vue'),
		meta: {
			title: "首页",
			value: "home",
			isShow: true
		},
	},
	{
		path: '/productCenter',
		name: 'productCenter',
		component: () => import('../views/productCenter.vue'),
		meta: {
			title: "产品与解决方案",
			value: "productCenter",
			isShow: true
		},
		children:[
			{
				path: 'yiyuan',
				name: 'yiyuan',
				component: () => import('../views/case.vue'),
				meta:{
					value: "yiyuan",
					isShow: false,
					title:"互联医院",
				}
			},
			{
				path: 'pay',
				name: 'pay',
				component: () => import('../views/case.vue'),
				meta:{
					value: "pay",
					isShow: false,
					title:"统一支付对账平台",
				}
			},
			{
				path: 'yuyue',
				name: 'yuyue',
				component: () => import('../views/case.vue'),
				meta:{
					value: "yuyue",
					isShow: false,
					title:"全资源预约平台",
				}
			},
			{
				path: 'xiaoxi',
				name: 'xiaoxi',
				component: () => import('../views/case.vue'),
				meta:{
					value: "xiaoxi",
					isShow: false,
					title:"智能消息资讯中心",
				}
			}
		]
	}, {
		path: '/case',
		name: 'case',
		component: () => import('../views/case.vue'),
		meta: {
			title: "经典案例",
			value: "case",
			isShow: true
		},
	}, {
		path: '/seekAdviceFrom',
		name: 'seekAdviceFrom',
		component: () => import('../views/seekAdviceFrom.vue'),
		meta: {
			title: "行业咨询",
			value: "seekAdviceFrom",
			isShow: false
		},
	}, {
		path: '/service',
		name: 'service',
		component: () => import('../views/service.vue'),
		meta: {
			title: "服务保障",
			value: "service",
			isShow: false
		},
	}, {
		path: '/about',
		name: 'about',
		component: () => import('../views/about.vue'),
		meta: {
			title: "关于惠宾",
			value: "about",
			isShow: true
		},
	}, {
		path: '/cooperate',
		name: 'cooperate',
		component: () => import('../views/cooperate.vue'),
		meta: {
			title: "商务合作",
			value: "cooperate",
			isShow: false
		},
	}, {
		path: '/',
		name: 'tel',
		component: () => import('../views/home.vue'),
		meta: {
			title: "",
			value: "tel",
			isShow: true
		},
	}

]

const router = new VueRouter({
	// mode: 'history',
	base: process.env.BASE_URL,
	routes,
	// 每次跳转滚动到页面最顶部  
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			return {
				x: 0,
				y: 0
			}
		}
	},
	
})
router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		// document.title = to.meta.title;  
	}  
	next();
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
export default router